module.exports = __webpack_public_path__ + "img/CABALLETES.9e648c2b.png";